import { graphql } from '../../graphql/generated';

export const INSURANCES_QUERY = graphql(`
  query Insurances {
    insurances {
      id
      name
      shortName
      code
      mappings
    }
  }
`);
